import i18next from "i18next";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MODALS } from "common";
import { selectAppModalData, setAppModal } from "redux/slices/appSlice";
import css from "./seatUsage.module.scss";
import { Button } from "components";

export default function SeatUsage() {
  const dispatch = useDispatch();
  const data = useSelector(selectAppModalData(MODALS.SEAT_USAGE)) || {};
  const activeSeats = Number(data.activeSeats) || 0;
  const totalSeats = Number.isFinite(Number(data.totalSeats))
    ? Number(data.totalSeats)
    : null;

  return (
    <section className={css.container} role="dialog" aria-modal="true" aria-labelledby="seat-usage-title">
      <h2 id="seat-usage-title">{i18next.t("labels.seat_usage")}</h2>
      <p>{data.tenantName || ""}</p>
      <div className={css.metrics}>
        <div>
          <span>{i18next.t("labels.active_seats")}</span>
          <strong>{activeSeats}</strong>
        </div>
        <div>
          <span>{i18next.t("labels.total_seats")}</span>
          <strong>{totalSeats ?? i18next.t("labels.not_set")}</strong>
        </div>
      </div>
      <div className={css.actions}>
        <Button
          title={i18next.t("buttons.close")}
          onPress={() => dispatch(setAppModal(MODALS.NONE))}
        />
      </div>
    </section>
  );
}
